import { render, staticRenderFns } from "./svgRubika.vue?vue&type=template&id=bb8a1afe&scoped=true"
import script from "./svgRubika.vue?vue&type=script&lang=js"
export * from "./svgRubika.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8a1afe",
  null
  
)

export default component.exports